import { getTheme } from "PFCore/get_theme";

export const injectTheme = (theme?: string, themeConfig?: Record<string, string>) => {
  const themeVars = getTheme(theme, themeConfig);

  Object.keys(themeVars).forEach((key) => document.documentElement.style.setProperty(key, themeVars[key]));
};
